import { render, staticRenderFns } from "./CAvatar.vue?vue&type=template&id=00897bb2&scoped=true&"
import script from "./CAvatar.vue?vue&type=script&lang=js&"
export * from "./CAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CAvatar.vue?vue&type=style&index=0&id=00897bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00897bb2",
  null
  
)

export default component.exports